<script>
import { useAdminStore } from "@/stores/adminStore";
export default {
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  data() {
    const adminStore = useAdminStore();
    return {
      adminStore,
    };
  },
  computed: {
    isActive() {
      return {
        active: this.adminStore.users.status === "active",
      };
    },
  },
};
</script>
<template>
  <div
    class="profile-icon"
    :style="{ backgroundColor: adminStore.stringToColor(name) }"
    @click="goToProfile"
  >
    {{ name[0] }}

    <div v-if="isActive" class="online-indicator"></div>
  </div>
</template>

<style scoped>
.profile-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 50%;
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
  color: white;
  cursor: pointer;
}

.online-indicator {
  position: absolute;
  bottom: 4px;
  right: 1px;
  width: 10px;
  height: 10px;
  background-color: var(--dark-facstory);
  border: 1px solid var(--bg-tertiary);
  border-radius: 50%;
}
</style>
